import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { LockIcon, DownloadIcon, HelpCircleIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="offer-section" className="py-24 bg-white" data-id="element-71">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-72">
        {/* FAQ */}
        <FadeIn data-id="element-73">
          <div className="mb-24" data-id="element-74">
            <h2 className="text-h2 text-center mb-12 flex items-center justify-center gap-3" data-id="element-75">
              <HelpCircleIcon className="w-8 h-8 text-teal" data-id="element-76" />
              Preguntas Frecuentes
            </h2>
            <div className="space-y-6" data-id="element-77">
              {[{
              q: '¿Necesito comprar equipo especial?',
              a: 'No, solo necesitas una pared sólida y una silla firme.'
            }, {
              q: '¿Es seguro si ya tengo dolores articulares?',
              a: 'Sí, al ser impacto cero, no hay golpeteo en las articulaciones.'
            }, {
              q: '¿Cuánto tiempo tengo acceso?',
              a: 'El manual es tuyo para siempre una vez descargado.'
            }].map((faq, i) => <div key={i} className="bg-cream p-6 rounded-xl" data-id="element-78">
                  <h4 className="font-bold text-xl text-navy mb-2" data-id="element-79">{faq.q}</h4>
                  <p className="text-body text-charcoal/80" data-id="element-80">{faq.a}</p>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Offer + Price Block */}
        <FadeIn delay={0.2} data-id="element-81">
          <div id="price-block" className="bg-navy text-white rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-82">
            {/* Decorative background */}
            <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 bg-teal/20 rounded-full blur-3xl" data-id="element-83"></div>
            <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-64 h-64 bg-teal/20 rounded-full blur-3xl" data-id="element-84"></div>

            <div className="relative z-10" data-id="element-85">
              <h2 className="text-h2 text-white mb-6" data-id="element-86">
                Recupera tu tranquilidad
              </h2>
              <p className="text-body-lg text-cream/90 mb-8 max-w-2xl mx-auto" data-id="element-87">
                Tu independencia no tiene precio, pero fortalecerla no debería
                ser costoso. Accede hoy mismo al Protocolo Huesos Invencibles
                por un pago único. Recupera la tranquilidad de moverte por el
                mundo sin miedo.
              </p>

              <div className="mb-10" data-id="element-88">
                <span className="text-sm uppercase tracking-wider text-teal font-bold mb-2 block" data-id="element-89">
                  Precio Único
                </span>
                <span className="text-6xl font-serif font-bold text-white" data-id="element-90">
                  $6.39 <span className="text-2xl text-cream/70" data-id="element-91">USD</span>
                </span>
              </div>

              <Button onClick={() => window.open('https://cuerposabioo.com/cart/47962666991838:1', '_blank')} className="w-full sm:w-auto mx-auto mb-6 text-xl py-5 px-10" data-id="element-92">
                Haz clic aquí para descargar ahora
              </Button>

              <div className="flex items-center justify-center gap-6 text-sm text-cream/60" data-id="element-93">
                <span className="flex items-center gap-2" data-id="element-94">
                  <LockIcon className="w-4 h-4" data-id="element-95" /> Pago 100% seguro
                </span>
                <span className="flex items-center gap-2" data-id="element-96">
                  <DownloadIcon className="w-4 h-4" data-id="element-97" /> Descarga inmediata
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}